/**
 * Material Icon - Google Material Symbols Rounded wrapper
 * Provides a consistent interface for Material Symbols icons
 */

interface MaterialIconProps {
  /** Icon name from Material Symbols (use snake_case) */
  name: string;
  /** Icon size in pixels (default: 17px, 70% of Ant Design default) */
  size?: number;
  /** Fill state: 0 for outlined, 1 for filled (default: 0) */
  filled?: boolean;
  /** Font weight: 100-700 (default: 400) */
  weight?: number;
  /** Optical size: 20-48 (default: matches size) */
  opticalSize?: number;
  /** Additional CSS class names */
  className?: string;
  /** Additional inline styles */
  style?: React.CSSProperties;
  /** Mouse/click event handlers */
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseUp?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const MaterialIcon = ({
  name,
  size = 17, // 70% of 24px (Ant Design default) = ~17px
  filled = false,
  weight = 400,
  opticalSize,
  className = '',
  style = {},
  onClick,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
  onMouseUp,
}: MaterialIconProps) => {
  return (
    <span
      className={`material-symbols-rounded ${className}`}
      style={{
        fontSize: size,
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'opsz' ${opticalSize || size}`,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        userSelect: 'none',
        ...style,
      }}
      aria-hidden="true"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      {name}
    </span>
  );
};
